
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin, Checkbox } from 'antd';
import { useAppContext } from "../../../context/appContext";
import { CloseOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const CreateUserModal = ({ displayCreateUser, setDisplayCreateUser, onUserCreate, selectedUser = null, setSelectedUser }) => {

    const [signup, setSignup] = useState({
        email: null,
        password: null,
        password2: null,
        activated: false,
        bot_limit: 0,
        strategy_limit: 0,
    })

    const goBack = () => {
        setSelectedUser();
        setDisplayCreateUser(false)
    }

    useEffect(() => {
        if (selectedUser) {
            setSignup({
                id: selectedUser.id,
                email: selectedUser.email,
                password: '',
                password2: '',
                activated: selectedUser.activated,
                bot_limit: selectedUser.bot_limit,
                strategy_limit: selectedUser.strategy_limit,
            })
        }
    }, [selectedUser])
    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayCreateUser} footer={null} onCancel={() => { setSelectedUser(); setDisplayCreateUser(false); }}>
            <div style={{ fontWeight: "600", color: "white" }}>
                <svg style={{ position: "relative", top: 5, marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="15.724" height="22.759" viewBox="0 0 19.724 27.759">
                    <path id="Path_6013" data-name="Path 6013" d="M256.552,145.66c-.4-.171.116-.924.264-1.148a2.079,2.079,0,0,0,.425-.938,1.49,1.49,0,0,1,.326-.614,1.9,1.9,0,0,0,.265-1.308,1.29,1.29,0,0,1-.168-.562,4.089,4.089,0,0,0-.156-1.51,2.355,2.355,0,0,0-1.426-1.406A3.264,3.264,0,0,0,254.9,138h-.012a3.258,3.258,0,0,0-1.177.176,2.353,2.353,0,0,0-1.428,1.406,4.106,4.106,0,0,0-.159,1.51,1.228,1.228,0,0,1-.166.562,1.908,1.908,0,0,0,.263,1.308,1.524,1.524,0,0,1,.328.614,2.1,2.1,0,0,0,.425.938c.149.224.658.976.264,1.148-.261.113-3.367.872-4.062,1.687-.467.545-.159,1.119.6,1.282a39.54,39.54,0,0,0,10.234,0c.76-.163,1.067-.737.6-1.282-.7-.814-3.8-1.574-4.065-1.687Zm5.979-11.07H257.9a3.1,3.1,0,0,0-6,0h-4.633a2.231,2.231,0,0,0-2.228,2.229V157.8a2.23,2.23,0,0,0,2.228,2.228h15.269a2.231,2.231,0,0,0,2.228-2.228V136.819a2.231,2.231,0,0,0-2.227-2.229Zm-7.635-.74a1.525,1.525,0,0,1,1.3.739h-2.606A1.526,1.526,0,0,1,254.9,133.85ZM263.18,157.8a.65.65,0,0,1-.649.65h-15.27a.65.65,0,0,1-.649-.65V136.819a.65.65,0,0,1,.649-.65H262.53a.651.651,0,0,1,.649.65Zm-3.3-6.585h-9.974a.789.789,0,0,0,0,1.578h9.973a.789.789,0,0,0,0-1.578Zm-2.514,3.428h-7.461a.789.789,0,0,0,0,1.578h7.461a.789.789,0,0,0,0-1.578Zm2.514,0h-.442a.789.789,0,1,0,0,1.578h.442a.789.789,0,0,0,0-1.578Z" transform="translate(-245.034 -132.272)" fill="#fff" />
                </svg>
                {selectedUser ? "Update" : "Create"} user </div>
            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Email</label>
                <Input value={signup.email} onChange={(e) => { setSignup({ ...signup, email: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter email" />
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Password {selectedUser && "(Leave it empty if you don't want to change it)"}</label>
                <Input type="password" value={signup.password} onChange={(e) => { setSignup({ ...signup, password: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter password" />
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Type password again</label>
                <Input type="password" value={signup.password2} onChange={(e) => { setSignup({ ...signup, password2: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter the same password again" />
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Number of bots to be allowed</label>
                <Input value={signup.bot_limit} onChange={(e) => { setSignup({ ...signup, bot_limit: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter value" />
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Number of strategies to be allowed</label>
                <Input value={signup.strategy_limit} onChange={(e) => { setSignup({ ...signup, strategy_limit: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter value" />
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <Checkbox checked={signup.activated} style={{ color: "white" }} onChange={(e) => { setSignup({ ...signup, activated: e.target.checked }) }}>Activated</Checkbox>
            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button onClick={() => {
                    if (isNaN(signup.bot_limit)) {
                        message.error("Please enter numerical value for bot limit");
                        return;
                    }
                    if (isNaN(signup.strategy_limit)) {
                        message.error("Please enter numerical value for strategy limit");
                        return;
                    }
                    onUserCreate(signup, selectedUser ? 'update' : 'create')

                }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
            </div>
        </Modal >
    );
};

export default CreateUserModal;